import React from "react";
import { Spin } from "antd";
import "./fullScreenLoader.scss";

const FullScreenLoader = ({ loading }) => {
  if (!loading) return null;

  return (
    <div className="fullscreen-loader">
      <Spin size="large" />
    </div>
  );
};

export default FullScreenLoader;
